/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_AttachInputs */

const en_idea_attach = /** @type {(inputs: Idea_AttachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference`)
};

const id_idea_attach = /** @type {(inputs: Idea_AttachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referensi`)
};

/**
* | output |
* | --- |
* | "Reference" |
*
* @param {Idea_AttachInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_attach = /** @type {((inputs?: Idea_AttachInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_AttachInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_attach(inputs)
	return en_idea_attach(inputs)
});